import { fetchPublicRepsByAddress } from "./campaignApi";

/** @typedef {{ rep: object|null, senOne: object|null, senTwo: object|null, state?: string, district?: number }} NormalizedPublicReps */

/**
 * @param {object} data — API response from /api/public/reps-by-address/
 * @returns {NormalizedPublicReps}
 */
export function normalizePublicRepsResponse(data) {
  const senators = Array.isArray(data?.senators) ? data.senators : [];
  return {
    state: data?.state || "",
    district: data?.district ?? null,
    rep: data?.house_rep || data?.representative || null,
    senOne: data?.senator_one || senators[0] || null,
    senTwo: data?.senator_two || senators[1] || null,
  };
}

/**
 * @param {object|null} rep
 * @param {"representative"|"senator"|"delegate"} role
 */
export function publicRepToCongressMember(rep, role) {
  if (!rep) return null;
  const fullName = (rep.name || "").trim();
  const spaceIdx = fullName.indexOf(" ");
  const first_name = spaceIdx > 0 ? fullName.slice(0, spaceIdx) : fullName;
  const last_name = spaceIdx > 0 ? fullName.slice(spaceIdx + 1) : "";
  const bioguideId = rep.bioguide_id || rep.bioguideId || "";

  return {
    first_name,
    last_name,
    party: rep.party || "",
    bioguide_id: bioguideId,
    bioguideId,
    phone_number: rep.phone || "",
    phone: rep.phone || "",
    role,
    title: rep.title || "",
    office_address: rep.office || "",
    official_website_contact_url: "",
    official_website_url: "",
  };
}

/**
 * @param {NormalizedPublicReps} normalized
 * @param {boolean} [isDCResident]
 */
export function normalizedRepsToTakeActionMembers(normalized, isDCResident = false) {
  const repRole = isDCResident ? "delegate" : "representative";
  return {
    rep: publicRepToCongressMember(normalized.rep, repRole),
    senOne: publicRepToCongressMember(normalized.senOne, "senator"),
    senTwo: publicRepToCongressMember(normalized.senTwo, "senator"),
    state: normalized.state || "",
    district: normalized.district,
  };
}

/**
 * @param {{ street_1: string, city: string, state: string, zipcode?: string, zip_code?: string }} address
 */
export async function lookupPublicRepsByAddress(address) {
  const zip_code = (address.zip_code || address.zipcode || "").trim();
  const data = await fetchPublicRepsByAddress({
    street_1: address.street_1,
    city: address.city,
    state: address.state,
    zip_code,
  });
  return normalizePublicRepsResponse(data);
}
